import { createFileRoute } from "@tanstack/react-router";
import { CalendarDays } from "lucide-react";
import { z } from "zod";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { BOOKING_PANEL_STEPS, useBookingPanel } from "@/features/booking/hooks/use-booking-panel";
import { RequestsWaitingButton } from "@/features/booking/modules/requests/components/requests-waiting-button";
import { ScheduleTab } from "@/features/booking/modules/schedule/schedule-tab";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/booking/")({
  loader: () => ({ crumb: m.booking_schedule_page_title() }),
  // The open booking, the visit of a series, and the step it lands on. Emails and other pages link
  // here with all three, so the route has to keep them.
  validateSearch: z.object({
    bookingId: z.string().optional(),
    occurrence: z.string().optional(),
    step: z.enum(BOOKING_PANEL_STEPS).optional(),
  }),
  component: SchedulePage,
});

function SchedulePage() {
  const { openBooking } = useBookingPanel();

  return (
    <PageShell
      icon={CalendarDays}
      title={m.booking_schedule_page_title()}
      description={m.booking_schedule_page_description()}
      actions={<RequestsWaitingButton />}
    >
      <ScheduleTab onOpenBooking={openBooking} />
    </PageShell>
  );
}
